import {
  customerTypeOptions,
  entryFeeValue,
  ftesValue,
  legalStatusOptions,
  mergedAllTransactionTypeOptions,
  mergedOperationPhaseOptions,
  operationPhaseValue,
  sectorsValue,
  transactionTypeOptions,
  userRoleValue,
  xenditBankList
} from 'constant'

export const transactionTypeSelector = (val) => {
  if (Array.isArray(val)) {
    let tempArr = []
    val.forEach((v) => {
      mergedAllTransactionTypeOptions.forEach((el) => {
        if (el.value === v) {
          tempArr.push(el)
        }
      })
    })
    return {
      label: tempArr.map((item) => `${item.label}`).join(', '),
      value: tempArr.map((item) => `${item.label}`).join(', ')
    }
  }
  const found = mergedAllTransactionTypeOptions.find((el) => el.value === val)
  if (!found)
    return {
      label: val,
      value: val
    }
  return found
}

export const fteSelector = (val) => {
  const found = ftesValue.find((el) => el.value === val)
  if (!found)
    return {
      label: val,
      value: val
    }
  return found
}
export const legalStatusSelector = (val) => {
  const found = legalStatusOptions.find((el) => el.value === val)
  if (!found)
    return {
      label: val,
      value: val
    }
  return found
}

export const faseOperationSelector = (val = [], isMerged = false) => {
  let tempFile = []
  const options = isMerged ? mergedOperationPhaseOptions : operationPhaseValue
  val.forEach((v) => {
    options.forEach((el) => {
      if (el.value === v) {
        tempFile.push(el)
      }
    })
  })
  return tempFile.map((item) => `${item.label}`).join(', ')
}
export const sectorsSelector = (val = []) => {
  let tempFile = []
  val.forEach((v) =>
    [
      ...sectorsValue,
      // {
      //   label: 'Lainnya',
      //   value: 'others'
      // }
    ].forEach((el) => {
      if (el.value === v) {
        tempFile.push(el)
      }
    })
  )
  return tempFile.map((item) => `${item.label}`).join(', ')
}

export const transactionTypezSelector = (val) => {
  const found = transactionTypeOptions.find((el) => el.value === val)
  if (!found)
    return {
      label: val,
      value: val
    }
  return found
}
export const userRoleSelector = (val) => {
  const found = userRoleValue.find((el) => el.value === val)
  if (!found)
    return {
      label: val,
      value: val
    }
  return found
}
export const xenditBankSelector = (val) => {
  const found = xenditBankList.find((el) => el.value === val)
  if (!found)
    return {
      label: val,
      value: val
    }
  return found
}
export const customerTypeSelector = (val) => {
  const found = customerTypeOptions.find((el) => el.value === val)
  if (!found)
    return {
      label: val,
      value: val
    }
  return found
}
export const getEntryFeeObjectByValue = (value) => {
  return entryFeeValue?.find((fee) => fee.value == value)
}
export const getOperationPhaseObjectByValue = (value) => {
  return mergedOperationPhaseOptions.find((op) => op.value === value)
}
export function getLegalStatusObjectByValue(data) {
  return legalStatusOptions?.find((legalItem) => legalItem.value === data)
}
export function getCustomerTypeObjectByValue(data) {
  return customerTypeOptions?.find((custType) => custType.value === data)
}
export const getTransactionTypeByValue = (value, isValueOnly = false) => {
  if (Array.isArray(value)) {
    let tempArr = []
    value.forEach((v) => {
      mergedAllTransactionTypeOptions.forEach((el) => {
        if (el.value === v) {
          tempArr.push(isValueOnly ? el.value : el)
        }
      })
    })
    return tempArr
  }
  return mergedAllTransactionTypeOptions.find((tx) => tx.value === value)
}

export const getSectorObjByValue = (value) => {
  return sectorsValue?.find((sectorItem) => sectorItem.value === value)
}
